module.exports = __webpack_public_path__ + "img/mmi-volunteers-web-banner.5163b477.png";